// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as IconCmp$PorterinFeature from "../../../fare-estimate-v1/view/components/IconCmp.mjs";

function ClickableIconCmp(Props) {
  var class_name = Props.class_name;
  var on_icon_click = Props.on_icon_click;
  var icon = Props.icon;
  return React.createElement("div", {
              className: class_name,
              onClick: Curry.__1(on_icon_click)
            }, React.createElement(IconCmp$PorterinFeature.make, {
                  image: icon
                }));
}

var make = ClickableIconCmp;

export {
  make ,
}
/* react Not a pure module */
